<template>
  <div class="header-section">
    <div class="header-container">
      <div class="header-item cursor logo" @click="onClickHeaderItem('/')">
        <header-logo />
      </div>
      <nav class="header-item menu">
        <div
          v-for="(item, index) in headerItem"
          :key="'headerItem' + index"
          :class="['is-16b', 'menu-item', 'relative', {on: item.selected}]"
          @mouseover="toggleDropdown(index)"
          @click="onClickHeaderTitle(item)"
        >
          {{ item.name }}
          <!-- 드롭다운 박스 -->
          <div
            v-show="item.dropDown"
            class="dropdown-box absolute left-1/2 -translate-x-1/2 min-w-[100px] w-max bg-white shadow-md border rounded mt-2 z-10"
            @mouseover="toggleDropdown(index)"
            @mouseleave="closeDropdown(index)"
          >
            <div
              v-for="(subItem, subIndex) in item.dropDownItems"
              :key="'subItem' + subIndex"
              class="dropdown-item px-4 py-2 hover:bg-gray-100 is-14m cursor-pointer"
              @click.stop="navigateTo(item, subItem.path)"
            >
              {{ subItem.name }}
            </div>
          </div>
        </div>
      </nav>
      <div class="header-item login">
        <div v-if="isAuthenticated" class="login-wrap">
          <div class="is-16r" @click="onClickLogout">로그아웃</div>
          <div class="is-16r" @click="onClickHeaderItem('/mypage')">마이페이지</div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="cart-icon"
            @click="onClickHeaderItem('/cart')"
          >
            <g clip-path="url(#clip0_2583_54270)">
              <path
                d="M4.00081 6.41384L0.757812 3.17184L2.17281 1.75684L5.41481 4.99984H20.6568C20.8127 4.99983 20.9664 5.03625 21.1057 5.1062C21.245 5.17616 21.366 5.2777 21.459 5.40273C21.5521 5.52776 21.6147 5.67282 21.6417 5.82632C21.6688 5.97983 21.6595 6.13753 21.6148 6.28684L19.2148 14.2868C19.1531 14.4929 19.0265 14.6736 18.8539 14.802C18.6813 14.9305 18.4719 14.9999 18.2568 14.9998H6.00081V16.9998H17.0008V18.9998H5.00081C4.7356 18.9998 4.48124 18.8945 4.29371 18.7069C4.10617 18.5194 4.00081 18.2651 4.00081 17.9998V6.41384ZM5.50081 22.9998C5.10299 22.9998 4.72146 22.8418 4.44015 22.5605C4.15885 22.2792 4.00081 21.8977 4.00081 21.4998C4.00081 21.102 4.15885 20.7205 4.44015 20.4392C4.72146 20.1579 5.10299 19.9998 5.50081 19.9998C5.89864 19.9998 6.28017 20.1579 6.56147 20.4392C6.84278 20.7205 7.00081 21.102 7.00081 21.4998C7.00081 21.8977 6.84278 22.2792 6.56147 22.5605C6.28017 22.8418 5.89864 22.9998 5.50081 22.9998ZM17.5008 22.9998C17.103 22.9998 16.7215 22.8418 16.4402 22.5605C16.1588 22.2792 16.0008 21.8977 16.0008 21.4998C16.0008 21.102 16.1588 20.7205 16.4402 20.4392C16.7215 20.1579 17.103 19.9998 17.5008 19.9998C17.8986 19.9998 18.2802 20.1579 18.5615 20.4392C18.8428 20.7205 19.0008 21.102 19.0008 21.4998C19.0008 21.8977 18.8428 22.2792 18.5615 22.5605C18.2802 22.8418 17.8986 22.9998 17.5008 22.9998Z"
                fill="#606060"
              />
            </g>
            <defs>
              <clipPath id="clip0_2583_54270">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div v-else class="login-wrap">
          <div class="is-16r" @click="onClickHeaderItem('/login')">로그인</div>
          <div class="is-16r" @click="onClickHeaderItem('/signup')">회원가입</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useMemberStore} from '~/store/member/index.js'
import HeaderLogo from 'assets/svg/header-logo.vue'

export default {
  name: 'IndexHeader',
  components: {HeaderLogo},
  setup() {
    const store = useMemberStore()
    return {
      store
    }
  },
  computed: {
    isAuthenticated() {
      return this.store.isAuthenticated
    }
  },
  data() {
    return {
      headerItem: [
        {
          name: '회원사업',
          path: '/membership-business',
          selected: false,
          dropDownItems: [
            {
              name: '한국인사관리자 월례미팅',
              path: '/membership-business?menu=0&subMenu=0'
            },
            {
              name: '교육연수담당자 월례미팅',
              path: '/membership-business?menu=1&subMenu=0'
            },
            {
              name: '인사팀(부)장 교류회',
              path: '/membership-business?menu=2&subMenu=0'
            },
            {
              name: 'Korea CHO Forum',
              path: '/membership-business?menu=3&subMenu=0'
            }
          ]
        },
        {
          name: '공개강좌',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: '교육과정',
              path: '/seminar?menu=0&subMenu=0'
            },
            {
              name: '접수중 교육과정',
              path: '/seminar?menu=1&subMenu=0'
            },
            {
              name: '교육장 안내',
              path: '/seminar?menu=2&subMenu=0'
            },
            {
              name: '교육신청 방법',
              path: '/seminar?menu=3&subMenu=0'
            }
          ]
        },
        {
          name: '월간인사관리',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: '월간인사관리 안내',
              path: '/magazine?menu=0&subMenu=0'
            },
            {
              name: '목차',
              path: '/magazine?menu=1&subMenu=0'
            },
            {
              name: '월호보기',
              path: '/magazine?menu=2&subMenu=0'
            },
            {
              name: '구독 신청',
              path: '/magazine?menu=3&subMenu=0'
            },
            {
              name: '광고문의',
              path: '/magazine?menu=4&subMenu=0'
            },
          ]
        },
        {
          name: 'KPI 도서',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: 'KPI 도서',
              path: '/kpi-book'
            }
          ]
        },
        {
          name: 'HR 자료',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: '인사관리규정',
              path: '/hr?menu=0&subMenu=0'
            },
            {
              name: '연봉조사자료',
              path: '/hr?menu=1&subMenu=0'
            },
            {
              name: 'HR용어',
              path: '/hr?menu=2&subMenu=0'
            }
          ]
        },
        {
          name: '광고 및 제휴',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: '서비스 안내',
              path: '/partnership?menu=0&subMenu=0'
            },
            {
              name: '서비스 문의',
              path: '/partnership?menu=1&subMenu=0'
            }
          ]
        },
        {
          name: '고객센터',
          selected: false,
          dropDown: false,
          dropDownItems: [
            {
              name: '공지사항',
              path: '/customer-service?menu=0&subMenu=0'
            },
            {
              name: '찾아오시는 길',
              path: '/customer-service?menu=1&subMenu=0'
            },
            {
              name: '1:1문의',
              path: '/customer-service?menu=2&subMenu=0'
            },
            {
              name: '자주 묻는 질문',
              path: '/customer-service?menu=3&subMenu=0'
            },
            {
              name: '비용 관련 서류',
              path: '/customer-service?menu=4&subMenu=0'
            }
          ]
        }
      ],
      isAuth: false
    }
  },
  mounted() {
    this.isAuth = this.store.isAuthenticated
  },
  methods: {
    onClickHeaderTitle(item) {
      // item의 dropDownItems의 [0] path로 이동 하고 selected을 true로 변경
      this.headerItem = this.headerItem.map(header => {
        header.selected = header.name === item.name
        return header
      })
      // 드롭다운이 열려있으면 닫기
      this.headerItem = this.headerItem.map(header => {
        header.dropDown = false
        return header
      })
      this.$router.push(item.dropDownItems[0].path)
    },

    onClickHeaderItem(path) {
      this.headerItem = this.headerItem.map(item => {
        item.selected = false
        return item
      })
      this.$router.push(path)
    },
    toggleDropdown(index) {
      this.headerItem = this.headerItem.map((item, i) => {
        item.dropDown = i === index ? !item.dropDown : false
        return item
      })
    },
    closeDropdown(index) {
      this.headerItem = this.headerItem.map((item, i) => {
        item.dropDown = i === index ? false : item.dropDown
        return item
      })
    },
    navigateTo(item, path) {
      // 서비스 문의 로그인 필요
      const loginRequired = ['/partnership?menu=1&subMenu=0']
      if (loginRequired.includes(path) && !this.isAuthenticated) {
        alert('로그인 후 이용 가능합니다.')
        return
      }
      this.$router.push(path)
      this.headerItem = this.headerItem.map(item => {
        item.dropDown = false
        return item
      })
      this.headerItem = this.headerItem.map(header => {
        header.selected = header.name === item.name
        return header
      })
    },
    onClickLogout() {
      if (confirm('로그아웃 하시겠습니까?')) {
        this.store.logout()
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-section {
  height: 82px;

  .header-container {
    position: fixed;
    top: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 1080px;
    padding: 24px 32px;
    display: flex;
    align-items: center;
    border-radius: 100px;
    border: 1px solid #f2f4f8;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(16px);
    z-index: 30;

    .header-item {
      &.menu {
        display: flex;
        gap: 24px;
      }
      &.logo {
        margin-right: 36px;
      }
      &.login {
        margin-left: auto;
      }

      .menu-item {
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          color: #0058aa;
        }
      }

      .login-wrap {
        display: flex;
        gap: 16px;

        .is-16r {
          cursor: pointer;
          color: #606060;
        }

        .cart-icon {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
